import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';

import {
	MatCardModule,
	MatStepperModule,
	MatTabsModule,
	MatRippleModule,
	MatExpansionModule,
	MatButtonToggleModule,
	MatChipsModule,
	MatProgressSpinnerModule,
	MatProgressBarModule,
	MatDialogModule,
	MatTooltipModule,
	MatSnackBarModule,
	MatTableModule,
	MatSortModule,
	MatPaginatorModule,
	MatNativeDateModule,
	MatTreeModule,
	MatBadgeModule,
	MatBottomSheetModule,
	MatDividerModule,
} from '@angular/material';
import {
	MatButtonModule,
	MatInputModule,
	MatAutocompleteModule,
	MatDatepickerModule,
	MatFormFieldModule,
	MatRadioModule,
	MatSelectModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatMenuModule,
	MatSidenavModule,
	MatToolbarModule,
	MatGridListModule,
	MatCheckboxModule,
	MatListModule,
} from '@angular/material';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoitrComponent } from './components/autoitr/autoitr.component';

@NgModule({
	exports: [
		FormsModule,
		CommonModule,
		MatCheckboxModule,
		MatButtonModule,
		MatInputModule,
		MatAutocompleteModule,
		MatDatepickerModule,
		MatFormFieldModule,
		MatRadioModule,
		MatSelectModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatMenuModule,
		MatSidenavModule,
		MatToolbarModule,
		MatListModule,
		MatGridListModule,
		MatCardModule,
		MatStepperModule,
		MatTabsModule,
		MatExpansionModule,
		MatButtonToggleModule,
		MatChipsModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatDialogModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatTableModule,
		MatSortModule,
		MatPaginatorModule,
		MatNativeDateModule,
		MatMomentDateModule,
		MatTreeModule,
		MatRippleModule,
		MatBadgeModule,
		MatBottomSheetModule,
		MatDividerModule,
		FlexLayoutModule,
		ReactiveFormsModule
	],
})
export class SharedMaterialModule { }
